import CryptoJS from "crypto-js";
import { useSelector } from "react-redux";

const encryptData = (dataToEncrypt, encryptionKey) => {
  const encryptedParams = CryptoJS.AES.encrypt(
    dataToEncrypt,
    encryptionKey,
  ).toString();

  // Convertir Base64 a Base64 URL Safe
  return encryptedParams
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=/g, "");
};

function useRedirectionDBroker() {
  const user = useSelector((state) => state.user);

  const { email, usrcod, cdEjecutivoAdm } = user;

  const selectedFields = {
    email,
    usrcod,
    cdEjecutivoAdm,
  };

  const secretKey = "$$vC2x1_?mK";

  const baseUrl =
    "https://cotizador2.segurossuarez.com:7443/suarez-core/siniestros";

  const encryptedUrlParams = encryptData(
    JSON.stringify(selectedFields),
    secretKey,
  );

  const url = `${baseUrl}/${encryptedUrlParams}`;

  return url;
}

export default useRedirectionDBroker;
